import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Program } from './Program.mjs';
import { UniformGroup } from './UniformGroup.mjs';
import { Runner } from '@pixi/runner';
var Shader = /*#__PURE__*/function () {
  function Shader(program, uniforms) {
    _classCallCheck(this, Shader);
    this.uniformBindCount = 0;
    this.program = program;
    if (uniforms) {
      if (uniforms instanceof UniformGroup) {
        this.uniformGroup = uniforms;
      } else {
        this.uniformGroup = new UniformGroup(uniforms);
      }
    } else {
      this.uniformGroup = new UniformGroup({});
    }
    this.disposeRunner = new Runner("disposeShader");
  }
  _createClass(Shader, [{
    key: "checkUniformExists",
    value: function checkUniformExists(name, group) {
      if (group.uniforms[name]) {
        return true;
      }
      for (var i in group.uniforms) {
        var uniform = group.uniforms[i];
        if (uniform.group) {
          if (this.checkUniformExists(name, uniform)) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.uniformGroup = null;
      this.disposeRunner.emit(this);
      this.disposeRunner.destroy();
    }
  }, {
    key: "uniforms",
    get: function get() {
      return this.uniformGroup.uniforms;
    }
  }], [{
    key: "from",
    value: function from(vertexSrc, fragmentSrc, uniforms) {
      var program = Program.from(vertexSrc, fragmentSrc);
      return new Shader(program, uniforms);
    }
  }]);
  return Shader;
}();
export { Shader };